import React, { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Button,
  Card,
  CardBody,
  CardText,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
  UncontrolledTooltip,
} from "reactstrap"
import classnames from "classnames"
import {} from "store/actions"
import { isEmpty } from "lodash"
import { useDeepCompareEffect } from "hooks"
import AlertContainer from "components/Common/AlertContainer"
import { CLEAR_HEALTHDAY_STATE } from "store/healthday/actionTypes"
import EmptyContainer from "components/Common/EmptyContainer"
import BasicInfoTab from "./tabs/BasicInfoTab"
import {
  getCentreDetail as onGetCentreDetail,
  getCentreTypes as onGetCentreTypes,
} from "store/actions"

const CentreAddEdit = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const [tabValue, setTabValue] = useState("1")
  const [header, setHeader] = useState("")

  //////////////////HEALTHDAY STATE/////////////////////
  const { centre } = useSelector(state => state.healthday)
  //////////////////////////////////////

  useDeepCompareEffect(() => {
    dispatch(onGetCentreTypes())
    if (id === "new") {
      setHeader("Add Centre")
    } else {
      setHeader("Edit Centre")
      dispatch(onGetCentreDetail(id))
    }
  }, [dispatch, id])

  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title =
    "Centre | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)

  const toggleTab = tab => {
    if (tabValue !== tab) {
      setTabValue(tab)
    }
  }

  const NavItemTab = (navTitle, navValue, iconValue) => {
    return (
      <NavItem>
        <NavLink
          style={{ cursor: "pointer" }}
          className={classnames({
            active: tabValue === navValue,
          })}
          onClick={() => {
            toggleTab(navValue)
          }}
        >
          <span className="d-block d-sm-none">
            <i className={iconValue}></i>
          </span>
          <span className="d-none d-sm-block">{navTitle}</span>
        </NavLink>
      </NavItem>
    )
  }

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_HEALTHDAY_STATE })
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Centres" breadcrumbItem={header} />
          {id !== "new" && isEmpty(centre) ? (
            <EmptyContainer
              backURL="/centres"
              message="There is no such centre!"
              linkText="Go to Centres Page"
            />
          ) : (
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <CardTitle>Basic Information</CardTitle>
                    <p className="card-title-desc mb-4">
                      Fill all information below to Complete the Centre Details
                      Below
                    </p>
                    {/* {id !== "new" ? (
                      <Nav tabs className="nav-tabs-custom nav-justified">
                        {NavItemTab(
                          "Basic Info",
                          "1",
                          "mdi mdi-information-outline"
                        )}
                      </Nav>
                    ) : (
                      ""
                    )}
                    <TabContent activeTab={tabValue} className="p-3 text-muted">
                      <TabPane tabId="1"> */}
                    <Row>
                      <Col sm="12">
                        <BasicInfoTab centre={centre} />
                      </Col>
                    </Row>
                    {/* </TabPane>
                    </TabContent> */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CentreAddEdit
